// extracted by mini-css-extract-plugin
export default {"container":"SensorStatusMobileFloating_container__n-oIH","no-scrollbar":"SensorStatusMobileFloating_no-scrollbar__TsZe7"};